import { getUploadURL, updateTypes, } from "../ContentAPI";
export const SUCCESS = 1000;
// Function to extract video metadata from a video file
export const getVideoMetadata = (videoFile) => {
    return new Promise((resolve, reject) => {
        const video = document.createElement("video");
        const url = URL.createObjectURL(videoFile);
        video.preload = "metadata";
        video.onloadedmetadata = () => {
            const width = video.videoWidth;
            const height = video.videoHeight;
            const duration = video.duration;
            let orientation;
            if (width > height) {
                orientation = "landscape";
            }
            else if (height > width) {
                orientation = "portrait";
            }
            else {
                orientation = "square";
            }
            URL.revokeObjectURL(url);
            resolve({
                width,
                height,
                orientation,
                duration,
            });
        };
        video.onerror = () => {
            URL.revokeObjectURL(url);
            reject(new Error("Failed to load video metadata"));
        };
        video.src = url;
    });
};
export const VIDEO_UTIL_VIDEO_UPLOAD_FAILED = 31001;
export const VIDEO_UTIL_VIDEO_UPLOAD_FAILED_SIGNED_OUT = 31002;
export const VIDEO_UTIL_VIDEO_UPLOAD_FAILED_NO_FILES = 31003;
export const VIDEO_UTIL_VIDEO_UPLOAD_FAILED_NULL_FILE_ENTRY = 31004;
export const VIDEO_UTIL_VIDEO_UPLOAD_FAILED_VIDEO_LOAD_FAILED = 31005;
export const VIDEO_UTIL_VIDEO_UPLOAD_FAILED_NO_TARGET_SIZES = 31006;
export const VIDEO_UTIL_VIDEO_UPLOAD_FAILED_INVALID_FILETYPE = 31007;
export const VIDEO_UTIL_VIDEO_UPLOAD_FAILED_INVALID_RESPONSE_MISSING_CODE = 31008;
export const VIDEO_UTIL_VIDEO_UPLOAD_FAILED_MISSING_UPLOADER_URL = 31009;
export const VIDEO_UTIL_VIDEO_UPLOAD_FAILED_UNSUPPORTED_FORMAT = 31010;
export const uploadVideoData = (s3UploadUrl, videoFile, okCallback, errorCallback, cacheBusterStore, logger) => {
    if (logger) {
        logger.log("uploadVideoData: uploadUrl = " +
            s3UploadUrl +
            ", videoFile = " +
            videoFile.name);
    }
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/octet-stream");
    const request = new Request(s3UploadUrl, {
        method: "PUT",
        body: videoFile,
        headers: myHeaders,
    });
    fetch(request)
        .then(function (res) {
        if (logger) {
            logger.log("uploadVideoData: RESULT = " + JSON.stringify(res));
        }
        okCallback(SUCCESS);
    })
        .catch(function (err) {
        if (logger) {
            logger.error("uploadVideoData: ERROR = " + err);
        }
        errorCallback(VIDEO_UTIL_VIDEO_UPLOAD_FAILED, "Failed to upload video file. " + err.message);
    });
};
export const uploadVideo = (input, callbacks, cacheBusterStore, logger) => {
    if (logger) {
        logger.log("uploadVideo");
    }
    if (!callbacks.authCallback.isSignedIn()) {
        callbacks.errorCallback(VIDEO_UTIL_VIDEO_UPLOAD_FAILED_SIGNED_OUT, "User is not signed in.");
        return;
    }
    const videoFile = input.videoFile;
    if (!videoFile) {
        callbacks.errorCallback(VIDEO_UTIL_VIDEO_UPLOAD_FAILED_NO_FILES, "No video file provided.");
        return;
    }
    // Validate video file type
    if (!videoFile.type.includes("video/mp4") &&
        !videoFile.type.includes("video/quicktime") &&
        !videoFile.name.toLowerCase().endsWith(".mp4") &&
        !videoFile.name.toLowerCase().endsWith(".mov")) {
        callbacks.errorCallback(VIDEO_UTIL_VIDEO_UPLOAD_FAILED_UNSUPPORTED_FORMAT, "Unsupported video format. Only MP4 and MOV files are supported.");
        return;
    }
    const getUploadURLCallback = (ok, status, response, cacheBusterStore) => {
        if (logger) {
            logger.log("getUploadURLCallback for video");
        }
        if (!ok) {
            if (!response || !response.clientDetailCode) {
                callbacks.errorCallback(VIDEO_UTIL_VIDEO_UPLOAD_FAILED_INVALID_RESPONSE_MISSING_CODE, "Status = " + status);
                return;
            }
            let errorMessage = "Unable to get upload URL for video.";
            if (response && response.error) {
                errorMessage = response.error;
            }
            callbacks.errorCallback(response === null || response === void 0 ? void 0 : response.clientDetailCode, errorMessage);
            return;
        }
        if ((response === null || response === void 0 ? void 0 : response.bearer) && (response === null || response === void 0 ? void 0 : response.sequence)) {
            callbacks.authCallback.setBearerAndSequence(response === null || response === void 0 ? void 0 : response.bearer, Number(response === null || response === void 0 ? void 0 : response.sequence));
        }
        if (logger) {
            logger.log("Got Video Upload URL = " + (response === null || response === void 0 ? void 0 : response.url));
        }
        const videoUploadUrl = response === null || response === void 0 ? void 0 : response.url;
        if (!videoUploadUrl) {
            callbacks.errorCallback(VIDEO_UTIL_VIDEO_UPLOAD_FAILED_MISSING_UPLOADER_URL, "Unable to get video upload URL; missing result.");
            return;
        }
        // Upload Video Data
        uploadVideoData(videoUploadUrl, videoFile, (clientDetailCode) => {
            if (logger) {
                logger.log("Video upload ok - " + clientDetailCode);
            }
            callbacks.okCallback(clientDetailCode);
        }, (clientDetailCode, errorMessage) => {
            if (logger) {
                logger.error("Video upload failed - " + clientDetailCode + " " + errorMessage);
            }
            callbacks.errorCallback(clientDetailCode, "Failed to upload video. " + errorMessage);
            return;
        }, cacheBusterStore, logger);
    };
    const bearer = callbacks.authCallback.bearer();
    const sequence = callbacks.authCallback.sequence();
    const userId = callbacks.authCallback.userId();
    if (!callbacks.authCallback.isSignedIn() || !bearer || !sequence || !userId) {
        callbacks.errorCallback(VIDEO_UTIL_VIDEO_UPLOAD_FAILED_SIGNED_OUT, "User is not signed in.");
        return;
    }
    const contentId = input.targetParameters.contentId;
    if (logger) {
        logger.log("Video contentId: " + contentId);
    }
    getUploadURL(getUploadURLCallback, userId, contentId, input.targetParameters.partition, input.targetParameters.fileType, bearer, sequence, cacheBusterStore);
};
export const updateVideoTypesBestEffort = (auth, partitionId, contentPrefix, cacheBusterStore, logger) => {
    logger.log("updateVideoTypesBestEffort");
    if (!auth.isSignedIn(logger) || !auth.userId || !auth.bearer) {
        logger.log("updateVideoTypesBestEffort: not signed in - skipped.");
        return;
    }
    const callbacks = (ok, status, response) => {
        logger.log("updateVideoTypesBestEffort.callback: " +
            ok +
            " " +
            status +
            " " +
            JSON.stringify(response));
        if (ok && response && response.bearer && response.sequence) {
            auth.setBearerAndSequence(response.bearer, Number(response.sequence), logger);
        }
    };
    logger.log("updateVideoTypesBestEffort: contentPrefix = " +
        contentPrefix +
        ", partitionId = " +
        partitionId);
    updateTypes(callbacks, auth.userId, contentPrefix, partitionId, auth.bearer, auth.sequence, cacheBusterStore);
};
export const generateVideoThumbnail = (videoFile, canvas, callback, errorCallback, logger) => {
    if (logger) {
        logger.log("generateVideoThumbnail");
    }
    const video = document.createElement("video");
    video.preload = "metadata";
    video.muted = true;
    video.playsInline = true;
    video.onloadedmetadata = () => {
        // Seek to 1 second or 10% of video duration, whichever is smaller
        const seekTime = Math.min(1, video.duration * 0.1);
        video.currentTime = seekTime;
    };
    video.onseeked = () => {
        try {
            const context = canvas.getContext("2d");
            if (!context) {
                errorCallback("Unable to get canvas context for video thumbnail");
                return;
            }
            // Set canvas dimensions to video dimensions
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            // Draw video frame to canvas
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            // Get thumbnail as data URL
            const thumbnailDataUrl = canvas.toDataURL("image/jpeg", 0.8);
            // Clean up
            URL.revokeObjectURL(video.src);
            callback(thumbnailDataUrl);
        }
        catch (error) {
            if (logger) {
                logger.error("Error generating video thumbnail: " + error);
            }
            errorCallback("Failed to generate video thumbnail: " + error.message);
        }
    };
    video.onerror = (error) => {
        if (logger) {
            logger.error("Video loading error: " + error);
        }
        URL.revokeObjectURL(video.src);
        errorCallback("Failed to load video for thumbnail generation");
    };
    // Create object URL and set as video source
    const videoUrl = URL.createObjectURL(videoFile);
    video.src = videoUrl;
};
export const isVideoFile = (file) => {
    return (file.type === "video/mp4" ||
        file.type === "video/quicktime" ||
        file.name.toLowerCase().endsWith(".mp4") ||
        file.name.toLowerCase().endsWith(".mov"));
};
export const getVideoFileExtension = (file) => {
    if (file.type === "video/mp4" || file.name.toLowerCase().endsWith(".mp4")) {
        return "mp4";
    }
    return "mov";
};
/**
 * Generates the converted video URL by inserting '.convert.' before the file extension and changing to .m3u8
 * @param originalVideoUrl - The original video URL (e.g., "u/user123/video.mp4")
 * @returns The converted HLS video URL (e.g., "u/user123/video.convert.m3u8")
 */
export const getConvertedVideoUrl = (originalVideoUrl) => {
    const lastDotIndex = originalVideoUrl.lastIndexOf(".");
    if (lastDotIndex === -1) {
        // No extension found, append .convert.m3u8
        return originalVideoUrl + ".convert.m3u8";
    }
    const nameWithoutExtension = originalVideoUrl.substring(0, lastDotIndex);
    // Always use .m3u8 for converted videos since MediaConvert outputs HLS
    return nameWithoutExtension + ".convert.m3u8";
};
/**
 * Generates the poster/thumbnail URL for a video post from its post JSON URL.
 *
 * The infra pipeline (notifyVideoUpload) requests a MediaConvert FrameCapture
 * output with NameModifier ".thumb", and MediaConvert appends a 7-digit frame
 * counter — so the object that actually lands in S3 is
 * "{postId}.thumb.0000000.jpg" (verified against prod). There is no
 * "{postId}_512.jpg" for video posts; that name exists only for image posts.
 *
 * @param postJsonUrl - The post JSON URL (e.g., "u/user123/chan/post.json")
 * @returns The thumbnail URL (e.g., "u/user123/chan/post.thumb.0000000.jpg")
 */
export const getVideoThumbnailUrl = (postJsonUrl) => {
    return postJsonUrl.replace(/\.json$/, ".thumb.0000000.jpg");
};
/**
 * Generates the original video URL from a converted HLS video URL
 * @param convertedVideoUrl - The converted HLS video URL (e.g., "u/user123/video.convert.m3u8")
 * @returns The original video URL (e.g., "u/user123/video.mp4")
 */
export const getOriginalVideoUrl = (convertedVideoUrl) => {
    return convertedVideoUrl
        .replace(".convert.m3u8", ".mp4")
        .replace(".convert.mov", ".mov");
};
